module.exports = __webpack_public_path__ + "static/media/star.c4b77425.png";